import Onboarding3 from "../../components/Onboarding3";

export default function OnboardingPage3() {
    return (
        <Onboarding3 />
    )
};